import Title from "antd/es/typography/Title";
import { AutoComplete, Card, Col, Flex, Row, Table } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/pro-solid-svg-icons";
import { NavLink, useNavigate } from "react-router-dom";
import { WAREHOUSE_SETTINGS_ROOT } from "../RouteConstants";
import ReactCountryFlag from "react-country-flag";
import { faPenToSquare } from "@fortawesome/pro-duotone-svg-icons";
import { getRowClassName } from "../../helpers/common";
import { useState } from "react";
import useWarehouse from "../../customHooks/useWarehouse";
import AppButton from "../../common/AppButton";

const columns = [
  {
    title: "",
    dataIndex: "id",
    key: "id",
    width: 48,
    render: (id) => (
      <NavLink to={`${WAREHOUSE_SETTINGS_ROOT}/details`} state={{ warehouseId: id }}>
        <FontAwesomeIcon
          icon={faPenToSquare}
          className="text-xl text-black block p-3 hover:text-cyan-500"
        />
      </NavLink>
    ),
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Port Of Discharge",
    dataIndex: "podCode",
    key: "podCode",
    render: (podCode) => (
      <Flex align="center" gap={4}>
        <ReactCountryFlag countryCode={podCode.slice(0, 2)} svg />
        {podCode}
      </Flex>
    ),
  },
  {
    title: "Short Code",
    dataIndex: "shortCode",
    key: "shortCode",
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
    render: (address) => (
      <Flex align="center" gap={4}>
        {address.addressLine1}{address.addressLine2 ? `, ${address.addressLine2}` : ""}, {address.city}, {address.state}, {address.zipCode}
      </Flex>
    ),
  },
];

const WarehouseMainPage = () => {
  const [searchQuery, setSearchQuery] = useState(null);
  const { data, isLoading } = useWarehouse(searchQuery);
  const navigate = useNavigate();

  return (
    <div className="px-8">
      <Flex
        vertical
        gap={12}
        className="md:flex md:flex-row md:justify-between md:items-center"
      >        <Title className="header-title" level={3}>Warehouses</Title>
        <div className="flex justify-around gap-2 mr-8">
          <AutoComplete placeholder="Search warehouse"
                        className="w-72"
                        size="middle"
                        prefix={<FontAwesomeIcon className="mr-2" icon={faSearch} />}
                        onChange={(value) => setSearchQuery(value)}
          />
          <AppButton variant="new" onClick={() =>
            navigate(`${WAREHOUSE_SETTINGS_ROOT}/details`, {
              state: {
                mode: "add",
              },
            })
          }>
            New
          </AppButton>
        </div>
      </Flex>
      <Row>
        <Col span={24}>
          <Card className="card-form">
            <Table dataSource={data}
                   columns={columns}
                   loading={isLoading}
                   rowKey="id"
                   size="small"
                   scroll={{ x: "max-content", y: "calc(100vh - 270px)" }}
                   rowClassName={getRowClassName}
                   pagination={false} />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default WarehouseMainPage;